export default __webpack_public_path__ + "static/media/grafema_+-identity_03.b3184c41.jpg";